import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { agProductsToExperienceProducts } from "@src/store/slices/agProducts/util/agProductsToExperienceProducts";
import { getProductType } from "@src/store/slices/experiences/selectors/products/getProductType";
import { getUnsavedAnalyticsProducts } from "@src/store/slices/experiences/selectors/products/getUnsavedAnalyticsProducts";
import { getUnsavedOfferProducts } from "@src/store/slices/experiences/selectors/products/getUnsavedOfferProducts";
import { ProductsAction } from "@src/store/slices/experiences/types";
import { selectedVariations } from "@src/store/slices/variations";

import { getProductsLocation } from "./getProducsLocation";
import { getUnsavedAgProducts } from "./getUnsavedAgProducts";

export const getExperienceProductsAction = createSelector(
  getProductsLocation,
  selectedVariations,
  getUnsavedAgProducts,
  getUnsavedOfferProducts,
  getUnsavedAnalyticsProducts,
  getProductType,
  (state: RootState) => state.experience.experience?.name,
  (state: RootState) => state.organization.organization?.shopId,
  (
    location,
    variations,
    unsavedAgProducts,
    unsavedOfferProducts,
    unsavedAnalyticsProducts,
    productType,
    name,
    shopId
  ): ProductsAction | undefined => {
    if (location) {
      return productType
        ? { type: "process", productType, location }
        : undefined;
    } else if (shopId && name) {
      if (unsavedAgProducts) {
        return {
          type: "upload",
          shopId,
          name,
          productType: "price",
          products: agProductsToExperienceProducts(
            unsavedAgProducts,
            variations
          ),
        };
      } else if (unsavedOfferProducts) {
        return {
          type: "upload",
          shopId,
          name,
          productType: "offer",
          products: unsavedOfferProducts,
        };
      } else if (unsavedAnalyticsProducts) {
        return {
          type: "upload",
          shopId,
          name,
          productType: "analytics",
          products: unsavedAnalyticsProducts,
        };
      }
    }
    return undefined;
  }
);
